import './EveryCourse.css';

const EveryCourse = (props) => {
  return (
    <>
      <div className="every-course">
        <>
        <img loading="lazy" src={props.course.imgURL} className="every-course-img" />
        <div className="every-course-name">{props.course.title}</div>
        <div className="every-course-price">
          <div className="every-course-price-text">Price:</div>
          <div className="every-course-price-free" style={{ fontWeight: 'medium' }}>FREE</div>
        </div>
        <div className="every-course-rating">
          <div className="every-course-rating-text">Ratings: {props.course.rating} </div>
          <div className="every-course-rating-all-stars">
            <div className="every-course-rating-single-star"></div>
          </div>
        </div>
        </>
         <div className="every-course-posted-by">
          <a href={props.course.courseURL} target="_blank" className="every-course-start-learning-link" >
            <button className="every-course-start-learning-button">Start Learning</button>
          </a>
        </div> 
      </div>
    </>
  );
};

export default EveryCourse;
